var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashbrd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.01824,
    height: 9.01824,
    rx: 3,
    transform: "matrix(-1 0 0 1 20.3059 11.7845)",
    fill: "#8B99A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.01824,
    height: 9.01824,
    rx: 3,
    transform: "matrix(-1 0 0 1 9.20593 0.685181)",
    fill: "#8B99A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.01824,
    height: 9.01824,
    rx: 3,
    transform: "matrix(-1 0 0 1 20.3057 0.685181)",
    fill: "#8B99A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.08452,
    height: 9.01824,
    rx: 0.5,
    transform: "matrix(-1 0 0 1 5.74023 11.7845)",
    fill: "#8B99A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.12695,
    height: 9.01824,
    rx: 0.5,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 9.20679 17.3571)",
    fill: "#8B99A7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbrd);
export default __webpack_public_path__ + "static/media/dashbrd.e715550bd50b7fa20779a6695a649440.svg";
export { ForwardRef as ReactComponent };